import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/base/services/base.service';


@Injectable({
  providedIn: 'root',
})
export class AtributoProcessoQuestaoService extends BaseService<any>{

  constructor(public http: HttpClient) {
    super(http)
  }

  public getListAtributos(): Observable<any[]>{
      return this.http.get<any[]>(this.baseUrl + '/list-atributos' , { headers: this.headers });
      let t = 1;
  }

  public getPathModule(): string {
    return '/pre-projeto/processo-questao';
  }
}
